import { ThreePsState } from "./threePsTypes";
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from "../threePsCodes.constants";

export const initialThreePsState: ThreePsState = {
    vendors: [],
    selectedVendor: null,
    codesByVendor: {},
    codesPageMetaByVendor: {},
    isEditMode: false,
    pageSize: DEFAULT_PAGE_SIZE,
    pageIndex: DEFAULT_PAGE_INDEX,
    totalThreePsCodes: 0,

    isVendorLoading: false,
    isCodesLoading: false,
    isSaveLoading: false,

    vendorsError: null,
    codesError: null,
    saveError: null,
}